<template>
    <div class="card">
        <div class="card-header p-0" id="headingLegend">
            <a
                class="btn btn-block text-left p-3"
                data-toggle="collapse"
                role="button"
                href="#collapseLegend"
                aria-expanded="false"
                aria-controls="collapseLegend">
                <h6 class="mb-0">{{ $t(`${modelTranslateID}.title`) }}</h6>
            </a>
        </div>

        <div id="collapseLegend"
            class="collapse"
            aria-labelledby="headingLegend"
            data-parent="">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <div class="form-check city-form-check pl-0">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    :id="`cb-status`"
                                    :name="`cb-status`"
                                    :disabled="readonlyForm"
                                    v-model="form.legend_automatic"
                                    :false-value="false"
                                    :true-value="true"
                                    :data-vv-scope="vScope"
                                    v-validate="''"
                                    @input="onChangeLegendAutomatic">
                                <label class="form-check-label h-auto" :for="`cb-status`">
                                    <div class="d-flex flex-column align-items-start">
                                        <strong>{{ $t(`${modelTranslateID}.automatic`) }}</strong>
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-if="!form.legend_automatic">
                    <div class="col-12 mb-3">
                        <h6 class="font-weight-normal">{{ $t(`${modelTranslateID}.image`) }}</h6>
                        <div class="legend img-thumbnail">
                            <UploadMultipleImage
                                :disabled="readonlyForm"
                                name="legends"
                                imageSize="small"
                                imageClass="background-contain"
                                direction="horizontal"
                                v-model="legends"
                                :maxImage="1"
                                :multiple="false"
                                :noOverlay="true"
                                :showImageLimitMessage="false"
                                :data-vv-scope="vScope"
                                v-validate="''"
                                filenameProperty="filename"
                                pathProperty="path"
                                :typeProperty="null"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import ElementMixin from '../mixins/ElementMixin';

export default {
    name: 'LayerLegend',
    mixins: [
        ElementMixin,
    ],
    components: {
        UploadMultipleImage: () => import(/* webpackChunkName: "upload-multiple-image" */ '@/components/form/UploadMultipleImage.vue'),
    },
    props: {
        files: {
            type: Array,
            default: () => {return []},
        },
        idSubPanel: {
            type: String,
            default: 'legend',
        },
    },
    data() {
        return {
            form: this.value,
            legends: [],
        }
    },
    methods: {
        onChangeLegendAutomatic() {
            if(!this.form.legend_automatic){
                this.legends = [];
            }
        },

    },
    watch:{
        files: {
            immediate: true,
            deep: true,
            handler(value, oldValue){
                this.legends = value;
            },
        },
        legends: {
            deep: true,
            handler(value, oldValue){
                this.forceDirtyUpload('legends');
                this.$emit('update:files', value);
            },
        },
    }
}
</script>

<style scoped lang="scss">
    @import "@styles/_mixins.scss";
    .legend {
        max-width: 100%;
        height: 100%;
        min-height: 100px;

        @include sm {
            min-height: 150px;
        }
    }
</style>